import React from "react";
import Project from "../Project/Project";
import { projects } from "../../data";

const Projects = () => {
  return (
    <div className=" bg-indigo-900 pb-40 h-full">
      <div className="title text-white flex flex-col items-center justify-center gap-1 pt-3">
        <span className="mx-3  px-7 bg-gradient-to-r from-indigo-500 ... w-auto h-auto rounded-lg text-white text-xs mt-20">
          In this part I would like to show you some of the projects I have done
          until this moment...
        </span>
        <div className=" bg-pink-600 w-auto py-1  h-9 rounded-lg text-white  text-center px-1 text-lg   ">
          Create & inspire. It's Miguel
        </div>
      </div>
      <div className="rounded border-2 border-white my-3 mx-3 flex flex-wrap justify-center">
        {projects.map((item) => (
          <Project key={item.id} img={item.img} link={item.link} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
